import type { ZodObject, ZodTypeAny } from 'zod'

/**
 * Extracts required field keys from a Zod object schema. This is useful when you want to
 * indicate which fields are required in the UI.
 *
 * @param schema - A Zod object schema
 * @returns Array of keys (string) that are required (not optional or nullable)
 */
export function getRequiredFields<
	T extends ZodObject<Record<string, ZodTypeAny>>,
>(schema: T) {
	return Object.entries(schema.shape)
		.filter(([, value]) => {
			return !value.isOptional() && !value.isNullable()
		})
		.map(([key]) => key as keyof T['shape'])
}
